export const init = () => {
  const enabled360 = document.getElementById('360-enabled');
  const button360 = document.querySelector('.button-360');
  const holder360 = document.getElementById('holder-360');
  const checkbox360 = document.getElementById('checkbox-360');
  const loading360 = document.querySelector('.loading-360');
  const product360Json = document.getElementById('product360Json');

  if (holder360 && checkbox360) {

    const loadModule = () => {
      if (loading360.classList.contains('hidden')) {
        loading360.classList.remove('hidden');
      }
      import('@/catalog/product-details/product-360/product-360-initialize').then(module => {
        loading360.classList.add('hidden');
        module.init();
      }).catch((e) => {
        console.warn(e);
        $('#main-container').pushAlert({
          text: window.Messages('product.load360.error'),
          type: 'danger',
          icon: 'bell'
        });
      });
    };

    checkbox360.addEventListener('change', loadModule, { once: true });

    cube.event.on('fwSlider_thumbnailClicked', () => {
      checkbox360.checked = false;
    });

    cube.event.on('modelChanged', (modelCode) => {
      checkbox360.removeEventListener('change', loadModule);
      checkbox360.checked = false;
      const modelsData = JSON.parse(cube.$id('pdm_productdetailsmaincartridge').dataset.pdmjsmodels);
      const newModel = modelsData.find(model => model.id === modelCode);
      const data360 = newModel && newModel.media && newModel.media.threeSixtyDegreesImages || null;
      product360Json.innerHTML = JSON.stringify({ 'product360': data360 });
      if(data360 && enabled360.value === 'true') {
        button360.classList.remove('hidden');
        holder360.classList.remove('hidden');
        checkbox360.addEventListener('change', loadModule, { once: true });
      } else {
        button360.classList.add('hidden');
        holder360.classList.add('hidden');
      }
    });
  }
};





// WEBPACK FOOTER //
// ./src/catalog/product-details/product-360.entry.js